import React, { useContext, useEffect } from 'react';
import NavContext from "../NavContext";
var HeaderToolsRaccourcis = function (_a) {
    var children = _a.children;
    var setHasMenu = useContext(NavContext).setHasMenu;
    useEffect(function () {
        setHasMenu(true);
    }, [setHasMenu]);
    return (React.createElement("ul", { className: "fr-btns-group" }, children));
};
export default HeaderToolsRaccourcis;
